/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Pinterest API for Conversions helpers (Pro)
 *
 * The user data, click ID validation and base payload the Conversions API
 * events carry. The adapter falls back to a base without user data when
 * pmw.getPinterestS2SBaseData is absent, which is the case on a free build.
 * */

(function (pmw, undefined) {

	// https://developers.pinterest.com/docs/conversions/best/
	// https://help.pinterest.com/en/business/article/pinterest-tag-parameters-and-cookies
	pmw.getPinterestUserDataFromBrowser = () => {

		let data = {}

		if (
			pmw.getCookie("_pin_unauth")
			|| pmw.getCookie("_pinterest_ct_rt")
			|| pmw.getCookie("_pinterest_ct")
			|| pmw.getCookie("_pinterest_ct_ua")
			|| pmw.getCookie("_pinterest_sess")
		) {
			data.trackingPermitted = true
		}

		// https://developers.pinterest.com/docs/conversions/event/
		// Not 100% if this must be an array or not.
		// On https://developers.pinterest.com/docs/conversions/event/ it is specified as an array.
		// On the setup guide it is specified as a string: https://cln.sh/z5FZsDM8

		let epik = pmw.getCookie("_epik") || pmw.retrieveData("epik")
		if (pmw.isValidEpikCookie(epik)) {
			data.click_id = epik
		}

		if (
			!data.click_id
			&& pmw.getCookie("_derived_epik")
			&& pmw.isValidDerivedEpikCookie(pmw.getCookie("_derived_epik"))
		) {
			data.click_id = pmw.getCookie("_derived_epik")
		}

		if (navigator.userAgent) data.client_user_agent = navigator.userAgent

		if (pmwDataLayer?.pixels?.pinterest?.advanced_matching) {
			if (pmwDataLayer?.user?.email?.pinterest) data.em = [pmwDataLayer.user.email.pinterest]
			if (pmwDataLayer?.user?.phone?.pinterest) data.ph = [pmwDataLayer.user.phone.pinterest]
			if (pmwDataLayer?.user?.first_name?.pinterest) data.fn = [pmwDataLayer.user.first_name.pinterest]
			if (pmwDataLayer?.user?.last_name?.pinterest) data.ln = [pmwDataLayer.user.last_name.pinterest]
			// Only a registered customer has a WordPress user ID. Pinterest
			// scores the external ID's coverage and uses it to tie a shopper's
			// events together, so a guest falls back to the hashed email
			// address, which is the shop's stable identity for them.
			const externalId = pmwDataLayer?.user?.id?.sha256 || pmwDataLayer?.user?.email?.pinterest
			if (externalId) data.external_id = [externalId]
			if (pmwDataLayer?.user?.city?.pinterest) data.ct = [pmwDataLayer.user.city.pinterest]
			if (pmwDataLayer?.user?.state?.pinterest) data.st = [pmwDataLayer.user.state.pinterest]
			if (pmwDataLayer?.user?.postcode?.pinterest) data.zp = [pmwDataLayer.user.postcode.pinterest]
			if (pmwDataLayer?.user?.country?.pinterest) data.country = [pmwDataLayer.user.country.pinterest]
		}

		return data
	}

	pmw.isValidEpikCookie = (cookie) => {

		// The following are two valid _epik cookies. Create a regex that checks if a cookie is valid. The function should return true if the cookie is valid and false if it is not.
		// dj0yJnU9aUYyam5aN0N6SjhMZU1pTk1iRTdfUnlNcXRpdHJ1c2UmcD0xJm49QVJEX2VPajVWUWtramc4MUZTWlRfZyZ0PUFBQUFBR1JfV1BN
		// dj0yJnU9dms1bVZPSEFfWEJOazJjQ2pxemExX0NMVy0yUlV6M2EmcD0xJm49RFI4bjBfSjlheE9PMXhrWXltbmFhdyZ0PUFBQUFBR1JfVzVJ

		// Create a regex that checks if a cookie is valid. The function should return true if the cookie is valid and false if it is not.
		return (/^dj0yJnU9[a-zA-Z0-9\-\_]{100}/).test(cookie)
	}

	pmw.isValidDerivedEpikCookie = (cookie) => {

		// The following are valid _derived_epik cookies:
		// dj0yJnU9dkV4amp4ZkN4S3c2UzVXTXp3V09OeGVXZHg4WElPczQmbj1oOTBzWUZSZEJHYkNuUXU1TEpvamJRJm09MSZ0PUFBQUFBR1JfV1JnJnJtPTEmcnQ9QUFBQUFHUl9XUmcmc3A9NQ
		// dj0yJnU9VHNZZGQwM25sdXFNcEt6TzlXdFl6WGxraHZfaml1dHkmbj11Y3RHRXNQUzQwSjBIWnZla19HV0xBJm09MSZ0PUFBQUFBR1JfWEFrJnJtPTEmcnQ9QUFBQUFHUl9YQWsmc3A9NQ

		return (/^dj0yJnU9[a-zA-Z0-9\-\_]{134}/).test(cookie)
	}

	pmw.getPinterestS2SBaseData = () => {

		// Get user data and strip browser-only internal flags before including in S2S payload
		const userData = pmw.getPinterestUserDataFromBrowser();
		delete userData.trackingPermitted;

		let data = {
			action_source   : "web",
			event_time      : Math.round(Date.now() / 1000),
			event_id        : pmw.getRandomEventId(),
			event_source_url: window.location.href,
			// opt_out         : false,
			// partner_name: "direct",
			user_data: userData,
		}

		let language = navigator.language || navigator.userLanguage
		if(language) {
			data.language = language
		}

		return data
	}

}(window.pmw = window.pmw || {}));
